export default [{
  "fullName": "Alanine",
  "abbreviation": "Ala",
  "symbol": "A",
  "molWeight": 89.09,
  "charge": 0,
  "hydrophobicityRB": 2.15,
  "pK": 0,
  "surface": 115,
  "volume": 88.6,
  "solubility": 16.65,
  "hydrophobicity": 1,
  "property": "Total aliphatic; hydrophobic"
}, {
  "fullName": "Arginine",
  "abbreviation": "Arg",
  "symbol": "R",
  "molWeight": 174.2,
  "charge": 1,
  "hydrophobicityRB": 2.23,
  "pK": 12,
  "surface": 225,
  "volume": 173.4,
  "solubility": 15,
  "hydrophobicity": -2,
  "property": "Acidic side chains; strongly polar; cationic"
}, {
  "fullName": "Asparagine",
  "abbreviation": "Asn",
  "symbol": "N",
  "molWeight": 132.12,
  "charge": 0,
  "hydrophobicityRB": 1.05,
  "pK": 0,
  "surface": 160,
  "volume": 114.1,
  "solubility": 3.53,
  "hydrophobicity": -1,
  "property": "Strongly polar"
}, {
  "fullName": "Asparticacid",
  "abbreviation": "Asp",
  "symbol": "D",
  "molWeight": 133.1,
  "charge": -1,
  "hydrophobicityRB": 1.13,
  "pK": 4.4,
  "surface": 150,
  "volume": 111.1,
  "solubility": 0.778,
  "hydrophobicity": -2,
  "property": "Acidic side chains; strongly polar; anionic"
}, {
  "fullName": "Cysteine",
  "abbreviation": "Cys",
  "symbol": "C",
  "molWeight": 121.15,
  "charge": 0,
  "hydrophobicityRB": 1.2,
  "pK": 8.5,
  "surface": 135,
  "volume": 108.5,
  "solubility": 1000,
  "hydrophobicity": 1,
  "property": "Polar side chains; semipolar"
}, {
  "fullName": "Glutamine",
  "abbreviation": "Gln",
  "symbol": "Q",
  "molWeight": 146.15,
  "charge": 0,
  "hydrophobicityRB": 1.65,
  "pK": 0,
  "surface": 180,
  "volume": 143.8,
  "solubility": 2.5,
  "hydrophobicity": -1,
  "property": "Strongly polar"
}, {
  "fullName": "Glutamicacid",
  "abbreviation": "Glu",
  "symbol": "E",
  "molWeight": 147.13,
  "charge": -1,
  "hydrophobicityRB": 1.73,
  "pK": 4.4,
  "surface": 190,
  "volume": 138.4,
  "solubility": 0.864,
  "hydrophobicity": -2,
  "property": "Acidic side chains; strongly polar; anionic"
}, {
  "fullName": "Glycine",
  "abbreviation": "Gly",
  "symbol": "G",
  "molWeight": 75.07,
  "charge": 0,
  "hydrophobicityRB": 1.18,
  "pK": 0,
  "surface": 75,
  "volume": 60.1,
  "solubility": 24.99,
  "hydrophobicity": 1,
  "property": "Semipolar"
}, {
  "fullName": "Histidine",
  "abbreviation": "His",
  "symbol": "H",
  "molWeight": 155.16,
  "charge": 1,
  "hydrophobicityRB": 2.45,
  "pK": 6.5,
  "surface": 195,
  "volume": 153.2,
  "solubility": 4.19,
  "hydrophobicity": -2,
  "property": "Basic side chains; strongly polar; cationic"
}, {
  "fullName": "Isoleucine",
  "abbreviation": "Ile",
  "symbol": "I",
  "molWeight": 131.17,
  "charge": 0,
  "hydrophobicityRB": 3.88,
  "pK": 0,
  "surface": 175,
  "volume": 166.7,
  "solubility": 4.117,
  "hydrophobicity": 1,
  "property": "Branched chain aliphatic; hydrophobic"
}, {
  "fullName": "Leucine",
  "abbreviation": "Leu",
  "symbol": "L",
  "molWeight": 131.17,
  "charge": 0,
  "hydrophobicityRB": 4.1,
  "pK": 10,
  "surface": 170,
  "volume": 166.7,
  "solubility": 2.426,
  "hydrophobicity": 1,
  "property": "Branched chain aliphatic; hydrophobic"
}, {
  "fullName": "Lysine",
  "abbreviation": "Lys",
  "symbol": "K",
  "molWeight": 146.19,
  "charge": 1,
  "hydrophobicityRB": 3.05,
  "pK": 0,
  "surface": 200,
  "volume": 168.6,
  "solubility": 1000,
  "hydrophobicity": -2,
  "property": "Acidic side chains; strongly polar; cationic"
}, {
  "fullName": "Methionine",
  "abbreviation": "Met",
  "symbol": "M",
  "molWeight": 149.21,
  "charge": 0,
  "hydrophobicityRB": 3.43,
  "pK": 0,
  "surface": 185,
  "volume": 162.9,
  "solubility": 3.81,
  "hydrophobicity": 1,
  "property": "Totally alyphatic"
}, {
  "fullName": "Phenylalanine",
  "abbreviation": "Phe",
  "symbol": "F",
  "molWeight": 165.19,
  "charge": 0,
  "hydrophobicityRB": 3.46,
  "pK": 0,
  "surface": 210,
  "volume": 189.9,
  "solubility": 2.965,
  "hydrophobicity": 2,
  "property": "Totally aromatic"
}, {
  "fullName": "Proline",
  "abbreviation": "Pro",
  "symbol": "P",
  "molWeight": 115.13,
  "charge": 0,
  "hydrophobicityRB": 3.1,
  "pK": 0,
  "surface": 145,
  "volume": 112.7,
  "solubility": 162.3,
  "hydrophobicity": 1,
  "property": "Totally alyphatic"
}, {
  "fullName": "Serine",
  "abbreviation": "Ser",
  "symbol": "S",
  "molWeight": 105.09,
  "charge": 0,
  "hydrophobicityRB": 1.4,
  "pK": 0,
  "surface": 115,
  "volume": 89,
  "solubility": 5.023,
  "hydrophobicity": -1,
  "property": "Semipolar"
}, {
  "fullName": "Threonine",
  "abbreviation": "Thr",
  "symbol": "T",
  "molWeight": 119.12,
  "charge": 0,
  "hydrophobicityRB": 2.25,
  "pK": 0,
  "surface": 140,
  "volume": 116.1,
  "solubility": 1000,
  "hydrophobicity": -1,
  "property": "Semipolar"
}, {
  "fullName": "Tryptophan",
  "abbreviation": "Trp",
  "symbol": "W",
  "molWeight": 204.23,
  "charge": 0,
  "hydrophobicityRB": 4.11,
  "pK": 0,
  "surface": 255,
  "volume": 227.8,
  "solubility": 1.136,
  "hydrophobicity": 2,
  "property": "Totally aromatic"
}, {
  "fullName": "Tyrosine",
  "abbreviation": "Tyr",
  "symbol": "Y",
  "molWeight": 181.19,
  "charge": 0,
  "hydrophobicityRB": 2.81,
  "pK": 10,
  "surface": 230,
  "volume": 193.6,
  "solubility": 0.045,
  "hydrophobicity": 1,
  "property": "Hydrophobic; total aromatic"
}, {
  "fullName": "Valine",
  "abbreviation": "Val",
  "symbol": "V",
  "molWeight": 117.15,
  "charge": 0,
  "hydrophobicityRB": 3.38,
  "pK": 0,
  "surface": 155,
  "volume": 140,
  "solubility": 8.85,
  "hydrophobicity": 1,
  "property": "Branched chain aliphatic; hydrophobic"
}];
